module.exports = __webpack_public_path__ + "static/12-5cb9de3049d090402300a2c1f6b6c8e6.jpg";